import React from 'react';
import { Box, Chip } from '@mui/material';
import { UI } from '../../tokens';

// Time-window selector shared by the Metrics panels (node / edge / root). Matches the
// session-view chip styling (pill shape, weight, hover lift) while keeping the original
// "secondary" color so the metrics controls stay visually distinct from the graph chips.
const OPTIONS = [
  { label: '2 hours', value: 2 },
  { label: '6 hours', value: 6 },
  { label: '12 hours', value: 12 },
  { label: '1 day', value: 24 },
  { label: '7 days', value: 7 * 24 },
];

const chipSx = {
  height: 32,
  fontSize: 13,
  fontWeight: 600,
  borderRadius: UI.radiusPill,
  transition: 'box-shadow .15s ease, background-color .15s ease',
  '&:hover': { boxShadow: '0 2px 6px rgba(26,36,45,0.18)' },
};

export default function TimeframeChips({ timeFrame, setTimeFrame }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        gap: 1,
        mt: 2,
        mb: 1,
        mr: 2,
      }}
    >
      {OPTIONS.map((opt) => (
        <Chip
          key={opt.value}
          label={opt.label}
          variant={timeFrame === opt.value ? 'filled' : 'outlined'}
          color="secondary"
          onClick={() => setTimeFrame(opt.value)}
          sx={chipSx}
        />
      ))}
    </Box>
  );
}
